export function isValidName(name) {
    return name !== "" && /^[a-zA-Z0-9]+$/.test(name)
}

export function isValidEmail(email) {
    return /^\S+@\S+\.\S+$/.test(email)
}